var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132-212v-42h80v-434q0-24.75 17.625-42.375T272-748h516v28H272q-14 0-23 9t-9 23v434h213v42H132Zm471 0q-12.75 0-21.375-8.625T573-242v-348q0-12.75 8.625-21.375T603-620h196q12.75 0 21.375 8.625T829-590v348q0 12.75-8.625 21.375T799-212H603Zm-2-42h200v-338H601v338Zm0 0h200-200Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.2d23ee33e08d083ee60f7e574db58538.svg";
export { ForwardRef as ReactComponent };